"use strict";
/**
 * 捕获组件异常的高阶组件
 *
 * 使用方法：
    一、子组件异常时，空白显示
    function Com(props) {
        return (
            <div>${a}</div>
        )
    }
    export default WithErrorHandler(Com) ;


    二、子组件异常时，显示另一个占位组件ErrorCom
    function Com(props) {
        return (
            <div>${a}</div>
        )
    }
    function ErrorCom(props){
        return (
            <div>
            this is error com
            </div>
        )
    }
    export default WithErrorHandler(Com) ;
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var withErrorHandler = function (Com, FallbackCom) {
    var WithErrorHandlerCom = /** @class */ (function (_super) {
        __extends(WithErrorHandlerCom, _super);
        function WithErrorHandlerCom(props) {
            var _this = _super.call(this, props) || this;
            _this.state = {
                hasError: false
            };
            _this.displayName = Com.displayName || Com.name || 'Component';
            return _this;
        }
        WithErrorHandlerCom.prototype.componentDidCatch = function (error, info) {
            // 捕捉异常
            this.setState({ hasError: true });
            // 返回异常信息给服务器
            this.errorCallback(error, info, this.props);
            // 你可以在此处，手动调用 Beidou.captureException 将错误日志上报给北斗服务器
            typeof Beidou != 'undefined' && Beidou.captureException(error, info);
        };
        WithErrorHandlerCom.prototype.errorCallback = function (error, info, props) {
            console.error(error, info);
        };
        WithErrorHandlerCom.prototype.render = function () {
            var _a = this.props, forwardRef = _a.forwardRef, rest = __rest(_a, ["forwardRef"]);
            if (this.state.hasError) {
                // 子组件异常时，显示的内容
                return typeof FallbackCom == 'undefined' ? ('') : (react_1.default.createElement(FallbackCom, __assign({ ref: forwardRef }, rest), this.props.children));
            }
            else {
                return (react_1.default.createElement(Com, __assign({ ref: forwardRef }, rest), this.props.children));
            }
        };
        return WithErrorHandlerCom;
    }(react_1.Component));
    return react_1.default.forwardRef(function (props, ref) {
        return react_1.default.createElement(WithErrorHandlerCom, __assign({}, props, { forwardRef: ref }));
    });
};
exports.default = withErrorHandler;
